module.exports = "<router-outlet ></router-outlet>\n\n<!-- <div> (onReset)=\"reset($event)\"></div> -->\n\n\n"